import React from 'react';
import ImageTag from '../ImageTag/Index';
import Title from '../Title/Index'
import { Link } from 'react-router-dom';


const Categorycard = ({ Data }) => {
  console.log("Data:", Data.points);

  return (
  <>
    {Data?.linkActive === "1" ? (
       <Link to={`/our-services/${Data.slug}`}>
        <div className='cardStnComponent p-0 border-0 h-auto'>
        <div className='row'>     
        <div className='col-lg-6 col-12 float-start icons text-end px-lg-3 p-0'  data-aos="fade-left"
              data-aos-offset="100"
              data-aos-duration="800"
              data-aos-once="true"
              data-aos-easing="ease-in-sine">        
          <ImageTag ImagePath={Data.imagePath} alt={Data.title} ImageHeight={'400'} ImageWidth={'600'}/>
        </div>
        <div className='col-lg-6 col-12 float-start productContent text-white px-lg-3 p-0'>
          <Title firstHeading={Data.title} secondHeading={Data.heading} _class={'mb-4 description text-start'} _secondHeading={'text-start text-white'} subTitle={Data.descp} _spanClass={'text-white'}/>
          <ul className='text-black d-grid'>
        {Array.isArray(Data.points) && Data.points.map((list, index) => (
  <li key={index}>{list}</li>
))}
       </ul>
    <div data-aos="fade-up" data-aos-offset="100" data-aos-duration="500" data-aos-once="true" data-aos-easing="ease-in-sine">
          <Link to={`/our-services/${Data.slug}`}>
            <span className="text-white customButton">Know More</span>
          </Link>
        </div>
          </div>
        </div>
       
      </div>
      </Link>
    ) : (
      <div className='cardStnComponent p-0 border-0 h-auto'>
      <div className='row'>     
      <div className='col-lg-6 col-12 float-start icons text-end px-lg-3 p-0'  data-aos="fade-left"
            data-aos-offset="100"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-easing="ease-in-sine">        
        <ImageTag ImagePath={Data.imagePath} alt={Data.title} ImageHeight={'400'} ImageWidth={'600'}/>
      </div>
      <div className='col-lg-6 col-12 float-start productContent text-white px-lg-3 p-0'>
        <Title firstHeading={Data.title} secondHeading={Data.heading} _class={'mb-lg-4 mb-2 description text-start'} _secondHeading={'text-start text-white'} subTitle={Data.descp} _spanClass={'text-white'}/>
       {/* <ul className='text-white d-grid'>
        {Array.isArray(Data.points) && Data.points.map((list, index) => (
  <li key={index}>{list}</li>
))}
       </ul> */}
      </div>
      </div>
     
    </div>
    )}
  </>
  );
};

export default Categorycard;
